import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { TreeTableModule } from 'primeng/treetable';
import { FilterRetentionService } from './filter-retention.service';
import { DropdownModule } from 'primeng/dropdown';
import { CheckboxModule } from 'primeng/checkbox';
import { ButtonModule } from 'primeng/button';
import { SelectButtonModule } from 'primeng/selectbutton';
import { RadioButtonModule } from 'primeng/radiobutton';
import { InfoPopoverModule } from './info-popover/info-popover.module';
import { SiUnauthorizedComponent } from './si-unauthorized/si-unauthorized.component';
import { SiTimezoneComponent } from './si-timezone/si-timezone.component';
import { SiFeedbackComponent } from './si-feedback/si-feedback.component';
import { SiLandingPageComponent } from './si-landing-page/si-landing-page';
import { SiLoaderModule } from '@strategic-insights/ng-loader';
import { SiCustomerCommonService } from '../si-customers/si-common-customer.service';
import { NgxIndexedDBModule, DBConfig } from 'ngx-indexed-db';
import { SiKeyCloakLoginComponent } from './si-keycloak-redirect/si-keycloak-login/si-keycloak-login.component';
import { SiKeyCloakLogoutComponent } from './si-keycloak-redirect/si-keycloak-logout/si-keycloak-logout.component';
import { SiKeyCloakSSOComponent } from './si-keycloak-redirect/si-keycloak-sso/si-keycloak-sso.component';

const dbConfig: DBConfig = {
  name: "CCID",
  version: 1,
  objectStoresMeta: [
    {
      store: "filters",
      storeConfig: { keyPath: "id", autoIncrement: true },
      storeSchema: [
        { name: "key", keypath: "key", options: { unique: true } },
        { name: "value", keypath: "value", options: { unique: false } },
      ],
    },
  ],
};

@NgModule({
  imports: [
    CommonModule,
    TreeTableModule,
    InfoPopoverModule,
    DropdownModule,
    ButtonModule,
    FormsModule,
    InfoPopoverModule, DropdownModule, CheckboxModule, ButtonModule,
    RadioButtonModule, FormsModule, SelectButtonModule,
    SiLoaderModule,
    NgxIndexedDBModule.forRoot(dbConfig),
    ReactiveFormsModule,
  ],
  declarations: [
    SiUnauthorizedComponent,
    SiTimezoneComponent,
    SiLandingPageComponent,
    SiFeedbackComponent,
    SiKeyCloakLoginComponent,
    SiKeyCloakLogoutComponent,
    SiKeyCloakSSOComponent
  ],
  providers: [FilterRetentionService, SiCustomerCommonService],
  exports: [
    SiUnauthorizedComponent, SiTimezoneComponent, SiFeedbackComponent,
    InfoPopoverModule, SiLandingPageComponent, SiLoaderModule
  ]
})
export class SharedModule {}
